var GLOBAL_POPOVER_MOUNT_ELEMENT_CLASSNAME = 'cb-popover-portal';
var globalMountElement = null;
export var canUseDOM = !(typeof window !== 'object' || !document);
/**
 * Utility to return (or create) the default global mounting element
 * for the Popover.
 */
export var getDefaultGlobalPopoverMountElement = function () {
    if (!canUseDOM)
        return null;
    if (globalMountElement) {
        return globalMountElement;
    }
    var mountElement = document.querySelector(".".concat(GLOBAL_POPOVER_MOUNT_ELEMENT_CLASSNAME));
    if (mountElement) {
        globalMountElement = mountElement;
        return globalMountElement;
    }
    globalMountElement = document.createElement('div');
    globalMountElement.className = GLOBAL_POPOVER_MOUNT_ELEMENT_CLASSNAME;
    globalMountElement.setAttribute('role', 'region');
    document.body.append(globalMountElement);
    return globalMountElement;
};
//# sourceMappingURL=utils.js.map